export const enum Major {
  GENERAL_KNOWLEDGE = "GENERAL_KNOWLEDGE", // KIẾN THỨC CHUNG VỀ HÀNG KHÔNG DÂN DỤNG
  MOOC_DRIVE = "MOOC_DRIVE", // ĐIỀU KHIỂN XE/ MOOC BĂNG CHUYỀN
  CAR_DRIVE = "CAR_DRIVE", // ĐIỀU KHIỂN XE Ô TÔ THÔNG THƯỜNG (Xe tải, xe bán tải, xe chở khách, nhân viên trên khu bay từ 4 đến 30 chỗ, xe cứu thương, xe dẫn tàu bay)
  BUS_DRIVE = "BUS_DRIVE", // ĐIỀU KHIỂN XE CHỞ KHÁCH TRÊN KHU BAY TỪ 30 CHỖ TRỞ LÊN
  FOOD_CAR_DRIVE = "FOOD_CAR_DRIVE", // ĐIỀU KHIỂN XE SUẤT ĂN
  WATER_CAR_DRIVE = "WATER_CAR_DRIVE", // ĐIỀU KHIỂN XE CẤP NƯỚC SẠCH
  TRACTOR_TRUCK_DRIVE = "TRACTOR_TRUCK_DRIVE", // ĐIỀU KHIỂN XE ĐẦU KÉO
  AIRCRAFT_TRUCKS_NOT_TOWER_DRIVE = "AIRCRAFT_TRUCKS_NOT_TOWER_DRIVE", // ĐIỀU KHIỂN XE KÉO ĐẨY TÀU BAY DÙNG CẦN KÉO ĐẨY
  AIRCRAFT_TRUCKS_HAS_TOWER_DRIVE = "AIRCRAFT_TRUCKS_HAS_TOWER_DRIVE", // ĐIỀU KHIỂN XE KÉO ĐẨY TÀU BAY DÙNG CẦN KÉO ĐẨY
  FORKLIFTS_DRIVE = "FORKLIFTS_DRIVE", // ĐIỀU KHIỂN XE NÂNG HÀNG,
  EXCAVATOR_DRIVE = "EXCAVATOR_DRIVE", // ĐIỀU KHIỂN XE XÚC NÂNG
  RESTRICTED_MOVE_CAR_DRIVE = "RESTRICTED_MOVE_CAR_DRIVE", // ĐIỀU KHIỂN XE PHỤC VỤ HÀNH KHÁCH HẠN CHẾ KHẢ NĂNG DI CHUYỂN
}
